import ChannelChart from '@op/pages/Overview/KeyMetrics/MentionsSentiment/Channel';
import LanguageChart from '@op/pages/Overview/KeyMetrics/MentionsSentiment/Language';
import { DetailConfigType } from '../types';
import keyMetrics from '@op/operationLog/pages/keyMetrics';
import RatingChart from '@op/pages/Overview/KeyMetrics/GameStore/RatingChart';
import ReviewRating from '@op/pages/Overview/KeyMetrics/GameStore/ReviewRating';
import SteamChart from '@op/pages/Overview/KeyMetrics/GameStore/Steam/SteamChart';
import LeftChart from '@op/pages/Overview/KeyMetrics/Community/LeftChart';

export const KeyMetricsChannel: DetailConfigType = {
  Component: ChannelChart,
  buriedPoint: keyMetrics,
  defaultProps: {},
  title: 'Key Metrics',
};


export const KeyMetricsLanguage: DetailConfigType = {
  Component: LanguageChart,
  defaultProps: {},
  title: 'Key Metrics',
  buriedPoint: keyMetrics,
};


export const KeyMetricsMobileRatingChart: DetailConfigType = {
  Component: RatingChart,
  defaultProps: {},
  title: 'Added Reviews',
  // buriedPoint: keyMetrics,
};

export const KeyMetricsMobileReviewRating: DetailConfigType = {
  Component: ReviewRating,
  defaultProps: {},
  title: 'Added Reviews',
  // buriedPoint: keyMetrics,
};

export const KeyMetricsSteamChart: DetailConfigType = {
  Component: SteamChart,
  defaultProps: {},
  title: 'Added Reviews',
  // buriedPoint: keyMetrics,
};

export const KeyMetricsCommunityLeftChart: DetailConfigType = {
  Component: LeftChart,
  defaultProps: {},
  // buriedPoint: keyMetrics,
};

export const KeyMetricsCommunityStreamingLeftChart: DetailConfigType = {
  Component: LeftChart,
  defaultProps: {},
  detailPageOptions: {
    tableMode: 'streaming',
    showViewMore: false,
  },
};
